import { useMemo } from 'react';

const GRID_Y_VALUES = [25, 50, 75, 100];
const MAX_SHADING_BLOCKS = 10;
const SHADING_NAMES = Array.from({ length: MAX_SHADING_BLOCKS }, (_, i) => [
  `cheapShading-${i}`,
  `peakShading-${i}`,
]).flat();

const STATIC_BLACKLIST = [
  ...SHADING_NAMES,
  'nowToFutureLink',
  'nowDot',
  'transitionMarkers',
  'historicTransitionMarkers',
  'solarGenerationLineCopy',
  'xAxisLineLeft',
  'xAxisLineRight',
] as const;

/**
 * Returns the Voronoi tooltip blacklist for the SOC chart.
 *
 * Elements on this list will not trigger tooltips on hover. `nowDot` is
 * blacklisted — the historic segment at the intersection handles the tooltip.
 */
export const useTooltipBlacklist = (loopIsDisabled: boolean): string[] => {
  return useMemo(() => {
    const blacklist: string[] = ['nowLine', 'staleReferenceLine'];

    if (!loopIsDisabled) {
      blacklist.push('historicChart');
    }

    const gridNames = GRID_Y_VALUES.flatMap((y) => [`customGridLeft-${y}`, `customGridRight-${y}`]);

    blacklist.push(...(STATIC_BLACKLIST as readonly string[]), ...gridNames);

    return blacklist;
  }, [loopIsDisabled]);
};
